/*
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: Smart Chow
 * @LastEditTime: 2022-01-06 13:30:37
 * @FilePath: /nqc-ui/src/apps/modules/qc-check/_store/index.js
 */

const state = {}

const mutations = {}

const actions = {}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
